import { Card, Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BannerCard from "../../../common/components/BannerCard";
import { asMoney, viewDate } from "../../../common/constants/Helpers";
import { civilRequest } from "../../../state/connect-api";
import { useCivilCaseJudgementMutation } from "../../../state/globalApi";
import { setCivilMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";
import getConfigs from "../../../GetConfigs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CivilJudgement = ({ ...props }) => {
  const { activeCaseNumber, civilMaster } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const [getJudgement, { isLoading }] = useCivilCaseJudgementMutation();
  const [messageVisible, setMessageVisible] = useState<boolean>(true)
  const configurations = getConfigs([
    "ctCVLJudgmentTxt",
  ]);

  useEffect(() => {
    const lookupRequest = civilRequest(activeCaseNumber);
    const fetch = async () => {
      const judgement = await getJudgement(lookupRequest).unwrap();
      dispatch(setCivilMaster({ judgement: judgement }));
    };
    fetch();
  }, [activeCaseNumber, dispatch]);

  const columns = [
    { key: "date", dataIndex: "DATE", title: "JudgmentDate" },
    { key: "type", dataIndex: "CaseJudgementTypeDescription", title: "Type" },
    { key: "JudgmentToWhom", dataIndex: "JudgmentToWhom", title: "Judgement For" },
    { key: "amount", dataIndex: "JudgmentAmount", title: "Amount", ...asMoney },
    { key: "interestdate", dataIndex: "InterestBeginDate", title: "Interest Date", ...viewDate },
    { key: "interestrate", dataIndex: "InterestRate", title: "Interest Rate" },
    { key: "othercost", dataIndex: "OtherCostsAmount", title: "Other Cost", ...asMoney },
    { key: "courtcosts", dataIndex: "CourtCostsFlag", title: "Court Cost" }
  ];

  return (
    <Row gutter={[16, 16]}>
      {configurations.ctCVLJudgmentTxt && messageVisible && (
        <Col xl={23} lg={23} md={23} sm={23} xs={23}>
          <Card>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
            </div>
            <br />
            <div dangerouslySetInnerHTML={{ __html: configurations.ctCVLJudgmentTxt }} />
          </Card>
        </Col>
      )}
      <Col xl={23} lg={23} md={23} sm={23} xs={23}>
        <BannerCard title="Judgements">
          <Table loading={isLoading} columns={columns} dataSource={civilMaster?.judgement?.LIST} scroll={{ x: 720 }} size="small" />
        </BannerCard>
      </Col>
    </Row>
  );
};

export default CivilJudgement;
